const HERO_FALLBACK_BACKGROUNDS = [
	'radial-gradient(circle at 14% 18%, rgba(255, 255, 255, 0.32) 0, rgba(255, 255, 255, 0) 28%), radial-gradient(circle at 84% 22%, rgba(255, 215, 164, 0.46) 0, rgba(255, 215, 164, 0) 24%), linear-gradient(135deg, #5c6df3 0%, #7d59d8 42%, #f0b8a1 100%)',
	'radial-gradient(circle at 18% 84%, rgba(255, 255, 255, 0.28) 0, rgba(255, 255, 255, 0) 26%), radial-gradient(circle at 76% 24%, rgba(148, 255, 234, 0.28) 0, rgba(148, 255, 234, 0) 22%), linear-gradient(135deg, #114d7d 0%, #2d7b95 34%, #9fd6cf 100%)',
	'radial-gradient(circle at 76% 18%, rgba(255, 245, 188, 0.42) 0, rgba(255, 245, 188, 0) 20%), radial-gradient(circle at 18% 74%, rgba(255, 255, 255, 0.26) 0, rgba(255, 255, 255, 0) 30%), linear-gradient(135deg, #733a92 0%, #af5e9b 46%, #f0c98b 100%)',
	'radial-gradient(circle at 24% 24%, rgba(255, 255, 255, 0.24) 0, rgba(255, 255, 255, 0) 26%), radial-gradient(circle at 82% 78%, rgba(255, 190, 208, 0.3) 0, rgba(255, 190, 208, 0) 24%), linear-gradient(135deg, #1b5d51 0%, #2f8477 38%, #d7f0b5 100%)',
	'radial-gradient(circle at 82% 20%, rgba(255, 255, 255, 0.3) 0, rgba(255, 255, 255, 0) 24%), radial-gradient(circle at 16% 70%, rgba(192, 226, 255, 0.34) 0, rgba(192, 226, 255, 0) 22%), linear-gradient(135deg, #20365f 0%, #4960a5 44%, #d9b6ff 100%)',
]

const hashString = value => {
	let hash = 0
	const text = String(value || '')
	for (let index = 0; index < text.length; index += 1) {
		hash = (hash * 31 + text.charCodeAt(index)) | 0
	}
	return Math.abs(hash)
}

export const getHeroFallbackBackground = application => {
	const seed = [
		application?.id,
		application?.studentId,
		application?.university,
		application?.major,
	]
		.filter(Boolean)
		.join('::')

	return (
		HERO_FALLBACK_BACKGROUNDS[
			hashString(seed) % HERO_FALLBACK_BACKGROUNDS.length
		] || HERO_FALLBACK_BACKGROUNDS[0]
	)
}
